var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.isRouter ? 'router-link' : 'a',{tag:"component",attrs:{"href":_vm.isRouter ? null : _vm.href,"to":_vm.isRouter ? (_vm.to || _vm.href) : null}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }